/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2481
 */

module.exports = function () {
  this.__data__ = []
  this.size = 0
}
